export const applySilhouette = (uri) => {
  return new Promise((resolve, reject) => {
    // Create a new Image element to load the image.
    const img = new Image()

    // When the image is successfully loaded, resolve the Promise with the loaded image.
    img.onload = () => {
      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d")

      // Resize canvas
      canvas.width = img.width
      canvas.height = img.height
      ctx.drawImage(img, 0, 0)

      // Get image data
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
      const data = imageData.data

      // Apply silhouette effect
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i] // Red
        const g = data[i + 1] // Green
        const b = data[i + 2] // Blue
        const brightness = (r + g + b) / 3

        const LIMIT = (256 * 2) / 3

        if (brightness > LIMIT) {
          // Light areas -> make transparent (background)
          data[i] = 0
          data[i + 1] = 0
          data[i + 2] = 0
          data[i + 3] = 0
        } else {
          // Dark areas -> make black (silhouette)
          data[i] = 124
          data[i + 1] = 205
          data[i + 2] = 156
        }
      }

      ctx.putImageData(imageData, 0, 0)

      // Convert canvas to blob
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Canvas toBlob failed"))
          return
        }

        const blobUrl = URL.createObjectURL(blob)
        const canvasImg = new Image()

        canvasImg.onload = () => {
          URL.revokeObjectURL(blobUrl) // Clean up
          resolve(canvasImg)
        }

        canvasImg.onerror = (error) => {
          URL.revokeObjectURL(blobUrl)
          reject(error)
        }

        canvasImg.src = blobUrl
      }, "image/png") // You can specify image/jpeg if needed
    }

    // If there's an error loading the image, reject the Promise with the error.
    img.onerror = (error) => {
      reject(error)
    }

    // Set the 'src' attribute of the image to start loading it from the provided URI.
    img.src = uri
  })
}
